import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'relements/build/esm/decorators/loader';
import Button from 'relements/build/esm/ui/button';
import Dropdown from 'relements/build/esm/input/dropdown';

import connection from '@src/connection';

// Local
import * as maps from './maps';
import styles from './AddLanguage.scss';

@Loader({})
@connection(maps.listenToStores, maps.getStateFromStores)
export default class AddLanguage extends React.Component {
  state = {
    selectedLanguage: {},
    availableLanguageOptions: [],
  };

  componentDidMount() {
    const { allLanguages = [], supportedLanguages = [] } = this.props;

    const availableLanguage = allLanguages.filter(
      data => !supportedLanguages.includes(data.code)
    );
    const availableLanguageOptions = availableLanguage.map(language => {
      return {
        label: `${language.code.toUpperCase()} - ${language.name}`,
        ...language,
      };
    });

    this.setState({
      availableLanguageOptions,
    });
  }

  render() {
    return (
      <div className={styles.container}>
        <Dropdown
          options={this.state.availableLanguageOptions}
          label="Pick Language"
          placeholder="Please select the new language to be added"
          optionKey="label"
          value={this.state.selectedLanguage}
          onChange={value => this._updateCurrentLanguage(value)}
        />
        <Button
          className={styles.addButton}
          type={Button.TYPES.PRIMARY}
          onClick={this._addLanguage}
        >
          {' '}
          Add
        </Button>
      </div>
    );
  }

  _updateCurrentLanguage = value => {
    this.setState({
      selectedLanguage: value,
    });
  };

  _addLanguage = () => {
    const { supportedLanguages } = this.props;
    const { selectedLanguage } = this.state;
    if (!selectedLanguage.code) {
      maps.createAlert('Please select a language first');
      return;
    }

    const updatedLanguageList = supportedLanguages.concat(
      selectedLanguage.code
    );
    this.props.activateLoader();
    maps.addLanguageToBot(
      this.props.domain.id,
      updatedLanguageList,
      success => {
        this.props.deactivateLoader();
        if (success) {
          maps.updateCurrentLanguage(
            selectedLanguage.code,
            selectedLanguage.code
          );
          maps.closeComponentModal();
        }
      }
    );
  };
}

AddLanguage.defaultProps = {
  supportedLanguages: [],
  allLanguages: [],
};

AddLanguage.propTypes = {
  domain: PropTypes.object,
  supportedLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string,
      native_name: PropTypes.string,
    })
  ),
  allLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string,
      native_name: PropTypes.string,
    })
  ),
  activateLoader: PropTypes.func,
  deactivateLoader: PropTypes.func,
};
